import { IOrganisationType, ISaveOrganisationType, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class OrganisationTypeClient extends NewBaseClient<ISaveOrganisationType, IOrganisationType> {
    constructor() {
        super(supportApi, '/organisation-types');
    }
}

export const organisationTypeClient = new OrganisationTypeClient();
